import { useParams } from "react-router-dom";
import React, { useState, useRef, useEffect } from "react";
import masterProgrammesData from "../../../../data/masterProgrammesData";

const LearningOutcomes = () => {
  const { masterProgramme } = useParams();
  const programme = masterProgrammesData.find(
    (item) => item.id === masterProgramme
  );

  const courseName = programme?.title || "Programme"; 
  const learningOutcomes = programme?.learningOutcomes || [];
  const brochureLink = programme?.brochurelink || "#";

  const [showShadow, setShowShadow] = useState(false);
  const scrollRef = useRef(null);

  const handleScroll = () => {
    const el = scrollRef.current;
    if (!el) return;

    const isAtBottom = el.scrollHeight - el.scrollTop === el.clientHeight;

    setShowShadow(!isAtBottom);
  };

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    handleScroll();

    el.addEventListener("scroll", handleScroll);

    return () => el.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="md:scroll-mt-44 scroll-mt-16" id="learning-outcomes">
      <div className="">
        <div className="max-w-6xl mx-auto md:py-16 py-5 px-2 md:px-10 space-y-3">
          <div>
            <h1 className="text-white font-bold text-lg">
              Programme Learning Outcomes
            </h1>
          </div>


          <div className="w-10 h-1 bg-sdorange"></div>

          <div className="">
            <div>
              <p className="text-gray-300">
                Graduates of the{" "}
                <span className="font-semibold text-sdorange">
                  {courseName}
                </span>{" "}
                will demonstrate:
              </p>
            </div>
            <div className="relative mt-2 max-h-96 md:max-h-[17rem] rounded-l-md bg-sdbodywhite/10">
              <ul
                ref={scrollRef}
                className="overflow-y-scroll masscrollbar-custom p-2 space-y-2 mt-4 text-gray-300 max-h-96 md:max-h-[17rem]"
              >
                {learningOutcomes.map((outcome, index) => (
                  <li key={index}>
                    <div className="flex items-start space-x-2">
                      <div className="flex-shrink-0 mt-1">
                        <img
                          src="/image-fix/custom-icons/preferred-custom-pointer.svg"
                          alt="pointer"
                          className="w-7 h-auto"
                        />
                      </div>
                      <div className="flex-1">{outcome}</div>
                    </div>
                  </li>
                ))}
              </ul>

              {showShadow && (
                <div
                  className="pointer-events-none absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-black/70 to-transparent"
                  style={{ borderRadius: "0 0 0 0.375rem" }}
                />
              )}
            </div>
            <div>
              <p className="text-gray-300 mt-4">
                The full module-specific learning outcomes including
                Competences, Knowledge, Skills, and Module-Specific Skills are
                available for{" "}
                <a
                  href={`${brochureLink}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline text-blue-300 hover:text-blue-400 transition-colors"
                >
                  Download in the full Programme Brochure.
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LearningOutcomes;
